<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar"  :data="sidebarData" />


    <!-- ADD NEW -->
    <vs-button class="user_add_btn" type="filled" @click="addNewTicket" ><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> Add Ticket</vs-button>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search  :data="filteredTicketList">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">


          <vs-dropdown  vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div v-if="selected.lenght>0" class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
                 <vx-tooltip text="Search By Category" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter_category">Search By Category</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="categorySelected('Search By Category')">
                <span class="flex items-center">
                  <span  >ALL</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="category in categories" :key="category.id" @click="categorySelected(category.name)">
                <span class="flex items-center">
                  <span >{{ category.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>
           <vx-tooltip text="Search By Status" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">Search By Status</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Status')">
                <span class="flex items-center">
                  <span  >ALL</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="status in statuses" :key="status.id" @click="setSelected(status.name)">
                <!-- <vs-chip>
                        <span>{{status.name}}</span>
                  </vs-chip> -->
                <span class="flex items-center">
                  <div class="h-2 w-2 rounded-full mr-1" :class="'bg-'+status.color"></div>
                  <span >{{ status.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>

        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tickets.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tickets.length }} of {{ queriedtickets }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>
        <span >NAME</span>
        <!-- <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('name')" /> -->
        <!-- <feather-icon icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('name')" /> -->
        </vs-th>
        <vs-th>
        <span  @click="sorting('type')">CATEGORY</span>
        <feather-icon v-if="typeorder && typestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('type')" />
        <feather-icon v-if="!typeorder && typestate" icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('type')" />
        </vs-th>
        <vs-th>
        <span  @click="sortingstatus('status')">STATUS</span>
        <feather-icon v-if="statusorder && statusstate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        <feather-icon v-if="!statusorder && statusstate" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        </vs-th>
        <vs-th>
        <span  @click="sortingdate('date')">CREATED</span>
        <feather-icon v-if="dateorder && datestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingdate('date')" />
        <feather-icon v-if="!dateorder && datestate" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingdate('date')" />
        </vs-th>
        <vs-th>Action</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
               <vs-td>
                <router-link :to="{ path: '/ticket/'+ tr.id}" class="text-inherit product-name font-medium truncate"><strong>{{ tr.name }}</strong></router-link>
                <p class="cursor-auto">{{tr.description}}</p>
                <!-- <vs-chip class="cursor-auto">{{tr.category.name}}</vs-chip> -->
              </vs-td>
              <vs-td ><vs-chip>{{tr.category.name}}</vs-chip></vs-td>
              <vs-td > <vs-chip :color="tr.status.color">{{tr.status.name}}
              </vs-chip></vs-td>
              <vs-td>{{tr.created_at | formatDate}}</vs-td>
              <vs-td   class="whitespace-no-wrap">
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current"  icon="MoreVerticalIcon"></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item >
                      <router-link :to="{ path: '/ticket/'+ tr.id}" class="text-inherit product-name truncate"> <span class="flex items-center">
                   <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                   <span> View </span>
                </span> </router-link>
                  </vs-dropdown-item>
                    <vs-dropdown-item v-if="hasRole" >
                <span class="flex items-center"  @click="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2 " />
                  <span> {{ $t('common.edit') }} </span>
                </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="hasRole">
                <span class="flex items-center"   @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>{{ $t('common.delete') }}</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>
<script>
import DataViewSidebar from './DataViewSidebar.vue'
import {ALL_TICKETS, ME_DATA, REMOVE_TICKET} from "@/graphql";
import {ALL_TICKET_CATEGORIES,ALL_TICKET_STATUSES,} from '@/graphql'
import moment from 'moment'

export default {
  components: {
     'DataViewSidebar': DataViewSidebar,
      moment,
  },
  data () {
    return {
      tickets:[],
      selected: [],
      categories:[],
      statuses:[],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      custom_search_filter:'Search By Status',
      custom_search_filter_category:'Search By Category',
      typeorder:false,
      typestate:false,
      dateorder:true,
      datestate:false,
      statusorder:false,
      statusstate:false,
      userRolePermissions:[],
      hasRole:false,

    }
  },
filters: {
  formatTime: function (value) {
    if (value) {
    return moment(String(value),'h:mm A').format('h:mm A')
  }
  },
  formatDate: function (value) {
    if (value) {
    return moment(String(value)).format('MM/DD/YYYY h:mm A')
  }
  },
},
  computed: {
    filteredTicketList: function () {
      var custom_search_filter = this.custom_search_filter
       var custom_search_filter_category = this.custom_search_filter_category
       return this.tickets.filter(function(ticket) {
         if (custom_search_filter == 'Search By Status' && custom_search_filter_category== 'Search By Category') {
         return true;
        }
        if(custom_search_filter !== 'Search By Status'){
        return ticket.status.name.match(custom_search_filter);
        }
        if(custom_search_filter_category !== 'Search By Category'){
        return ticket.category.name.match(custom_search_filter_category);
        }
       return false
      });

    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.$store.state.dataList.products
    },
    queriedtickets () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.tickets.length
    },
  },
  methods: {
    checkPermission (checkPermission) {
      alert('reach')
      console.log(checkPermission)
    },
    getdata(value){
     if(value){
       this.get()
     }
     },
    categorySelected(value) {
    this.custom_search_filter ='Search By Status'
    this.custom_search_filter_category = value;
    },
   setSelected(value) {
   this.custom_search_filter_category = 'Search By Category'
   this.custom_search_filter = value;
    },
  addNewTicket(){
      this.sidebarData = {}
      this.toggleDataSidebar(true)
  },
  toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
   editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    StatusSuccess(status) {
      this.$vs.notify({
        title: "Ticket",
        text: status,
        color: 'success',
        position: 'top-right'
      })
     this.get()
    },
   sorting(type){
    this.typestate=true
    this.datestate=false
    this.statusstate=false
    var column=type
    this.dateorder=true
    this.statusorder=true
    var order=this.typeorder
    if(column=='type' && order==true){
    this.typeorder=!this.typeorder
    this.tickets.sort(function(a, b) {
    var textA = a.category.name.toUpperCase();
    var textB = b.category.name.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='type' && order==false){
    this.typeorder=!this.typeorder
    this.tickets.sort(function(a, b) {
    var textA = a.category.name.toUpperCase();
    var textB = b.category.name.toUpperCase();
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
  sortingdate(name){
   this.datestate=true
   this.typestate=false
   this.statusstate=false
   var column=name
   this.typeorder=true
   this.statusorder=true
   var dateorder=this.dateorder
  if(column=='date' && dateorder==true){
    this.dateorder=!this.dateorder
    this.tickets.sort(function(a, b) {
    var textA = a.created_at
    var textB = b.created_at
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='date' && dateorder==false){
    this.dateorder=!this.dateorder
    this.tickets.sort(function(a, b) {
    var textA = a.created_at
    var textB = b.created_at
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});

}
  } ,
  sortingstatus(name){
   this.statusstate=true
   this.typestate=false
   this.datestate=false
   var column=name
   this.typeorder=true
   this.dateorder=true
   var statusorder=this.statusorder
  if(column=='status' && statusorder==true){
    this.statusorder=!this.statusorder
    this.tickets.sort(function(a, b) {
    var textA = a.status.name.toUpperCase();
    var textB = b.status.name.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='status' && statusorder==false){
   this.statusorder=!this.statusorder
    this.tickets.sort(function(a, b) {
    var textA = a.status.name.toUpperCase();
    var textB = b.status.name.toUpperCase();
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
     confirmDeleteRecord (ticket) {
      this.DeletedItem=ticket.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${ticket.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
     deleteData(ticket) {
     this.$apollo
      .mutate({
        mutation: REMOVE_TICKET,
        variables: {
        id: this.DeletedItem,
     },
      })
      .then(response => {
              if (response.data.deleteTicket.status=='SUCCESS') {
                this.StatusSuccess('Delete Successfully')
                this.get()
            }
            }).catch(error => {
            console.log(error)
          });

     },
    get(){
         this.$apollo
      .mutate({
        mutation: ALL_TICKETS,
      })
      .then(response => {
        this.tickets=response.data.tickets
        this.dateorder=!this.dateorder
          this.sortingdate('date')

      })
    },
  },
  created () {
    const userRoles = JSON.parse(localStorage.getItem('user-roles'))
    this.role=userRoles[0]['name']
    this.get()

    this.$apollo
      .mutate({
        mutation: ALL_TICKET_CATEGORIES,
      })
      .then(response => {
        this.categories=response.data.ticketCategories
      })
      this.$apollo
      .mutate({
        mutation: ALL_TICKET_STATUSES,
      })
      .then(response => {
        this.statuses=response.data.ticketStatuses
      })

    this.$apollo
      .query({
        query: ME_DATA,
      })
      .then((response) => {
        this.userRolePermissions = response.data.me.roles[0].permissions
        var exists = this.userRolePermissions.some(function(permission) {
          return permission.name === "edit_tickets"
        });
    if(exists){
     this.hasRole=true
    }
    else {
      this.hasRole=false

    }
      }).catch((error) => {
        // window.location = '/login'
        console.log(error)
      });



  },
  mounted () {
    this.isMounted = true
  }
}
</script>
<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.center {
  border: 1px solid #c3c3c3;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 0px;
  margin:0px;
}
</style>
